import { useAutoneTranslation } from '@autone/translations';
import { type FC, type PropsWithChildren } from 'react';

import { Tooltip } from '../../../atoms/Tooltip';
import { useSidebarContext } from '../context/SidebarContext';

export const DataFreshnessWidgetTooltip: FC<
  PropsWithChildren<{
    show?: boolean;
  }>
> = ({ children, show = true }) => {
  const { common } = useAutoneTranslation();
  const { isMobile, state } = useSidebarContext();

  return (
    <Tooltip
      asChild
      content={
        isMobile || state === 'expanded' || !show
          ? undefined
          : common('data-age.global-widget.label')
      }
      side="right"
    >
      {children}
    </Tooltip>
  );
};
